export default {
  partCards: {
    partHeatNote: '熱源施加於零件本身，不包含包覆時增加的材料。',
    missingContact: '未建立接觸',
    cadVolume: 'CAD 體積',
    meshVolume: '網格體積',
    centre: 'CAD 中心',
    unmeasured: '尚未量測',
    perfect: '完美接觸',
    gap: '最大 CAD 間隙',
    perfectBanner: '零件間以完美熱接觸計算，未模擬接觸熱阻。',
    volumeWarning:
      '網格體積與 CAD 體積相差超過 10%。請確認 W/m³ 熱源，或以總瓦數指定零件功率。',
  },
  meshSweeps: {
    title: '網格掃掠',
    gciLabel: '網格收斂指標',
    comingSoon: '即將推出',
    gciDescription:
      '以目前的最大尺寸為基準掃掠元素大小，在 {{levels}} 個網格上以 {{ratio}}× 縮放，以估算離散化誤差。',
    advanced: '進階',
    refinementRatio: '細化比例',
    levels: '層級',
  },
  fea: {
    material: '材料',
    defaultMaterial: '預設材料',
    defaultMaterialHint:
      '提交時套用至所有未另行指定材料的本體；下方的組件材料設定會覆寫對應體積。',
    modes: '模態數',
    numberOfModes: '模態數量',
    numberOfModesHint: '1 至 50 的正整數。',
    bucklingHint:
      '係數乘以此載荷模式。線性挫屈是偏樂觀的上限，並非失效載荷預測。',
    condition: '狀態',
    density: '密度',
    elasticModulus: '彈性模數',
    poissonsRatio: '柏松比',
    yieldStrength: '降伏強度',
    tensileStrength: '抗拉強度',
    sweepAxes: 'DOE 掃掠軸',
    sweepAxesHint:
      '在一列輸入多個數值，該輸入就會隨設計點變化。上方的載荷與接觸數值仍是基準；只有你在此展開的列會隨設計點改變。',
    seedSweeping: '此分量正在掃掠 — 請在 DOE 掃掠軸編輯清單。',
    materials: {
      steel_304: '不鏽鋼 304',
      carbon_steel_1045: '碳鋼 1045',
      steel_structural: '結構鋼',
      aluminum_6061: '鋁合金 6061',
      aluminum_7075: '鋁合金 7075',
      titanium_ti6al4v: '鈦合金 Ti-6Al-4V',
      copper_c110: '銅 C110',
      brass_c360: '黃銅 C360',
      inconel_718: 'Inconel 718',
      pcabs: 'PC/ABS',
      polycarbonate: '聚碳酸酯',
      abs: 'ABS',
      nylon_66: '尼龍 66',
      peek: 'PEEK',
      ptfe: 'PTFE',
      hdpe: 'HDPE',
      aluminum_nitride: '氮化鋁',
      diamond_cvd: '鑽石 (CVD)',
      still_air: '靜止空氣',
      silicon: '矽',
      silicon_dioxide: '二氧化矽',
      alumina: '氧化鋁',
      silicone: '矽膠',
      acrylic: '壓克力',
      aluminum_5052: '鋁合金 5052',
      tungsten: '鎢',
    },
    // English scientific / expanded names for abbreviations — kept in English
    // so the canonical vocab is discoverable regardless of active locale.
    // Structural materials now source this from
    // `StructuralProperties.description` (structuralMaterials.gen.ts)
    // instead — see material-labels.ts. Only the THERMAL_MATERIAL_LIBRARY
    // entries remain here; they were out of scope for that migration.
    materialsFull: {
      aluminum_nitride: 'Thermal-management ceramic',
      diamond_cvd: 'Synthetic diamond heat spreader',
      // silicon / silicon_dioxide / silicone / aluminum_5052 / tungsten:
      // omit — display names are already plain English.
      alumina: 'Aluminum oxide ceramic',
      acrylic: 'Polymethyl methacrylate (PMMA)',
    },
  },
  feaTemplate: {
    structural: '結構',
    modal: '模態',
    buckling: '挫屈',
    thermal: '熱傳導',
    thermalRegime: '熱傳求解類型',
    thermalSteady: '定常',
    thermalTransient: '暫態',
  },
  thermal: {
    defaultMaterial: '固體材料',
    materialsByVolume: '各體積材料',
    defaultMaterialHint:
      '套用於所有體積的預設固體材料。當網格有 Volume_* 時，下方的逐體積選擇器會覆寫它。',
    defaultConvectionH: '預設對流係數',
    defaultConvectionHHint:
      '將面設為對流時使用的環境熱傳係數 h。不是固體材料物性 — 自然對流空氣 ~5–25、強制對流空氣 ~50–250、水 ~1000+ W/(m²·K)。',
    syncConvectionH: '將 h 套用到 {{count}} 個對流面',
    syncConvectionHEmpty: '尚無對流面可更新。',
    syncConvectionHTooltip: '將每個對流面的熱傳係數設為 {{h}} W/(m²·K)。',
    initialTemperature: '初始溫度',
    initialTemperatureHint:
      '分析開始時固體的均勻溫度，套用到每個固體體積的每個節點 (Nall)。不是面邊界條件 — 面載荷與對流在 BC 列。',
    initialTemperatureVolumes:
      '均勻套用到 {{volumes}} 的每個節點。不是面邊界條件 — 面載荷與對流在上方 BC 列。',
    initialTemperatureAllVolumes:
      '均勻套用到每個固體體積的每個節點 (Nall)。不是面邊界條件 — 面載荷與對流在上方 BC 列。',
    solverTitle: '定常熱傳導',
    solverBody:
      '求解器會迭代直到溫度場穩定。Overview 依殘差檢查與邊界通量積分的熱平衡評分 converged — Draft 中無可編輯的殘差目標。',
    transientSolverTitle: '暫態熱傳導',
    transientSolverBody:
      '求解器推進物理時間。Overview 依時段閘、能量平衡 (J) 與最大原理溫度邊界檢查評分 converged — Draft 中無可編輯的殘差目標。',
  },
  feaSolveLoop: {
    helpLabel: '步驟、增分與迭代如何巢狀',
    step: '步驟',
    increment: '增分',
    iteration: '迭代',
    stepRan: '步驟 · {{count}} 已執行',
    stepRequested: '步驟 · {{count}} 要求',
    incrementRan: '增分 · {{count}} 已執行',
    incrementRequested: '增分 · {{count}} 要求',
    iterationRan: '迭代 · 最大 {{count}}',
    iterationRequested: '迭代 · 最大 {{count}} 要求',
    stepHelp: '涵蓋整個時間週期的一個分析程序。',
    incrementHelp: '步驟內推進物理時間的一次前進（下方的 Δt 欄位）。',
    iterationHelp: '增分內為達到平衡而進行的 Newton 迭代，直到殘差收斂。',
  },
  transientTime: {
    title: '時間排程',
    hint: '熱傳步驟的長度與時間推進方式。選填欄位留空時使用自動預設。',
    period: '週期時間 (s)',
    periodHint: '此熱傳步驟的全部物理時間——求解器必須到達此週期才算完成。',
    initialIncrement: '初始增分 (s)',
    initialIncrementHint:
      '第一個時間步的大小。留空為週期時間的百分之一。邊界突變且網格很細時，加大可避免溫度下衝。',
    minIncrement: '最小增分 (s)',
    minIncrementHint: '回切時允許的最小時間步。留空則使用自動下限。',
    maxIncrement: '最大增分 (s)',
    maxIncrementHint: '增分放大時的上限。留空為週期時間的十分之一。',
    outputInterval: '輸出間隔 (s)',
    outputIntervalHint:
      '寫入結果時間軸溫度幀的間隔。留空則與初始增分相同（約 101 幀；不超過約 200）。',
    maxTemperatureChange: '每步最大 ΔT (K)',
    maxTemperatureChangeHint:
      '單一增分允許的最大溫度變化。任一節點超過此值時求解器會縮短步長。留空則僅由增分上下限決定。',
    fixedIncrements: '固定增分',
    fixedIncrementsHint:
      '使用固定時間步長（不自動回切）。預設關閉，以便殘差停滯時求解器可縮小步長。',
    maxIncrements: '最大增分數',
    maxIncrementsHint: '此熱傳步驟的時間步數上限。預設 1000。',
    autoPlaceholder: '自動',
  },
  feaAdvancedSummary:
    '已儲存的結構求解器輸入。請在「物理與邊界條件」中編輯材料、邊界條件、接觸與預載。',
  forceVector: {
    cannotBeZero: '力向量不可為零',
  },
  direction: {
    label: '方向',
    auto: '自動 — 流動軸（{{axis}}）',
    studyDefault: '研究預設值',
    custom: '自訂（x, y, z）',
    cannotBeZero: '方向向量不可為零',
    normalizedNote: '執行時將正規化為單位向量。',
    tooltip:
      '入口流動方向。套用於此研究的所有執行 — 速度掃掠只變化速率, 方向在各次執行間固定。選項：自動 (Auto) 依偵測到的流動軸；±X/±Y/±Z 對齊座標軸；自訂 (Custom) 允許輸入 (x, y, z) 向量（執行時正規化）。',
  },
  rasWarnings: {
    wallResolvingLead: 'k-ω SST 為壁面解析模型',
    wallResolvingBodyPre:
      '所選網格沒有邊界層。為取得準確結果，請在 MeshGen 中重新產生網格，並將邊界層目標設定為',
    wallResolvingBodyPost: '求解器仍會執行，但近壁面物理將不正確。',
    wallFunctionsLead: '{{model}} 使用壁面函數',
    wallFunctionsBodyPre: '理想值',
    wallFunctionsBodyPost:
      '所選網格沒有邊界層，結果可能不準確。建議以針對壁面函數設定的邊界層重新產生網格。',
    lengthScaleLead: '未設定紊流長度尺度 (turbulent length scale)',
    lengthScaleBodyPre: '後端會回退至',
    lengthScaleBodyPost:
      '對大多數 CAD 零件而言過大。請設為物體特徵長度（弦長、直徑、翼展）的約 7~10%，以取得更準確的初始 ω / ε。',
  },
  advanced: {
    title: '進階',
    convergenceCriteria: '收斂準則',
    solverSettings: '求解器設定',
    forceCoeffsTitlePrefix: '力係數',
    refArea: '參考面積（m²）',
    refChord: '參考弦長（m）',
    egValue: '例如 {{value}}',
    forceCoeffsHintPrefix: '留空以略過',
    forceCoeffsHintSuffix: '將不列入結果',
    refAreaInfo:
      '將氣動力正規化為 C_D / C_L 所用的投影正面積。翼型是弦長 × 展長；鈍體則為正對來流的面積。單位：m²。',
    refChordInfo:
      '將俯仰力矩正規化為 C_M 所用的特徵長度 — 通常取翼型弦長。單位：m。',
    presetsLabel: '預設組',
    presetFluent: '採用 Fluent / STAR-CCM+ 預設',
    presetLowRe: '低雷諾數 / 黏性次層 (Low-Re)',
  },
  // OpenFOAM SIMPLE 演算法覆寫欄位的標籤與 tooltip. 依 panel.md 慣例:
  // 用自然語言說明「這是什麼」+「什麼時候調」, 不放 OpenFOAM 字典
  // 內部鍵名. 工程領域術語 (SIMPLE、laminar、RAS、snappyHexMesh、hex/tet、
  // upwind、SST) 保留 — 屬於使用者知道的模型詞彙, 不是實作細節.
  openFoamOverrides: {
    booleans: {
      on: '啟用 (On)',
      off: '停用 (Off)',
    },
    endTime: {
      label: '最大迭代次數',
      description:
        '求解器迭代的硬性上限。執行以此上限或下方的殘差目標先達到者為準停止。預設：1000（層流）/2000（RAS）。',
    },
    maxRunTime: {
      label: '時間上限（小時）',
      description:
        '單次執行最多可用的時間（小時）。時間一到，求解器會正常停止並儲存進度，之後可以繼續執行。預設：4 小時，最多 11 小時。',
      outOfRange: '時間上限請設定在 1 分鐘到 11 小時之間。',
    },
    residualControlP: {
      label: '壓力殘差',
      description:
        '壓力殘差要收斂到多低才視為完成。越低表示收斂越緊, 執行時間越長。預設：1e-4。',
    },
    residualControlU: {
      label: '速度殘差',
      description:
        '速度殘差要收斂到多低才視為完成。速度比壓力更難收斂 — 除非有特別理由, 否則建議維持在 ~1e-4 以上。預設：5e-3。',
    },
    writeInterval: {
      label: '寫入間隔',
      description:
        '求解器將結果快照寫入磁碟的頻率（以迭代計）。值越低殘差圖越細緻, 但磁碟用量越高。預設：50。',
    },
    nNonOrthCorrectors: {
      label: '非正交修正次數',
      description:
        '每次迭代中用來補償歪斜單元的額外壓力修正次數。高度歪斜的四面體網格可提高至 3~4；以六面體為主的網格維持 2 即可。預設：2。',
    },
    relaxP: {
      label: '壓力鬆弛因子',
      description:
        '壓力的欠鬆弛 — 每次迭代混入多少新算出的壓力。越低越穩定, 但收斂越慢。預設：0.3（層流）/0.2（RAS）。',
    },
    relaxU: {
      label: '速度鬆弛因子',
      description:
        '速度的欠鬆弛。越低越穩定但越慢；0.5 在多數情況下兼顧穩定與速度。預設：0.5。',
    },
    relaxTurbulence: {
      label: '紊流鬆弛因子',
      description:
        '紊流場（k 及其耗散）的欠鬆弛。越低越穩定但越慢；若紊流值不穩定, 降至 0.3。僅 RAS 適用 — 層流下無作用。預設：0.5。',
    },
    gradScheme: {
      label: '梯度格式',
      description:
        '求解器如何在單元間近似梯度。「Unlimited」在接近正交的六面體網格上最快且準確；cell-limited 系列會在歪斜四面體網格上抑制梯度以防振盪。預設：unlimited。',
      options: {
        unlimited: '不限制 (Unlimited)',
        cell_limited_half: '單元限制 (半)',
        cell_limited_full: '單元限制 (全)',
      },
    },
    divScheme: {
      label: '對流格式',
      description:
        '求解器如何離散化動量對流。「Linear upwind」為 2 階且穩定, 是預設值。「Upwind」為 1 階, 適用邊緣網格；「limited linear」適用震波或大梯度情況。預設：linear upwind。',
      options: {
        upwind: '迎風 1 階 (Upwind)',
        linear_upwind: '線性迎風 2 階 (Linear upwind)',
        limited_linear: '限制線性 (Limited linear)',
        linear: '線性中央差分 (Linear)',
      },
    },
    linearSolvers: {
      label: '線性求解器',
      description:
        '各場的線性求解器覆寫。屬於進階高權限設定；目前無法在此面板中編輯。',
    },
    divSchemeTurbulence: {
      label: '散度格式，紊流 (div scheme, turbulence)',
      description:
        'k / ω / ε 的對流格式. 「Upwind」為 1 階穩定 — 預設. 2 階選項與 Fluent / STAR-CCM+ 預設一致.',
    },
    pInterpolation: {
      label: '壓力插值 (p interpolation)',
      description:
        '壓力於單元面上的插值方式. 留空採用預設線性 (linear) 插值; 選擇中點 (midPoint) 或立方 (cubic) 主要用於與其他求解器比對時對齊格式.',
      options: {
        linear: '線性 (Linear)',
        midPoint: '中點 (Midpoint)',
        cubic: '立方 (Cubic)',
      },
    },
    nutWallFunction: {
      label: 'ν_t 壁函數 (nut wall function)',
      description:
        '紊流黏性壁函數. 預設處理對數律區; Spalding 混合過渡層; LowRe 由網格解析黏性次層.',
      options: {
        nutkWallFunction: '對數律 (nutkWallFunction)',
        nutUSpaldingWallFunction: '混合 (nutUSpaldingWallFunction)',
        nutLowReWallFunction: '黏性次層 (nutLowReWallFunction)',
      },
    },
    kWallFunction: {
      label: 'k 壁函數 (k wall function)',
      description:
        '紊流動能壁函數. 預設對數律+過渡層皆穩定; LowRe 用於壁面解析網格.',
      options: {
        kqRWallFunction: '預設 (kqRWallFunction)',
        kLowReWallFunction: '黏性次層 (kLowReWallFunction)',
        fixedValue: '指定 BC (fixedValue)',
      },
    },
    omegaWallFunction: {
      label: 'ω 壁函數 (omega wall function)',
      description:
        '比耗散率壁函數. 預設為全 y+ 混合式; `fixedValue` 用於指定 BC 比對.',
      options: {
        omegaWallFunction: '全 y+ (omegaWallFunction)',
        fixedValue: '指定 BC (fixedValue)',
      },
    },
    epsilonWallFunction: {
      label: 'ε 壁函數 (epsilon wall function)',
      description: '耗散率壁函數. 供 k-ε 模型使用; LowRe 用於黏性次層解析網格.',
      options: {
        epsilonWallFunction: '對數律 (epsilonWallFunction)',
        epsilonLowReWallFunction: '黏性次層 (epsilonLowReWallFunction)',
      },
    },
    residualControlTurbulence: {
      label: '殘差，紊流 (residual, turbulence)',
      description: '紊流殘差 (k + ω 或 ε) 的收斂門檻. 預設: 1e-4.',
    },
    laplacianLimiter: {
      label: '拉普拉斯限制器 (Laplacian limiter)',
      description:
        '控制面梯度校正的強度. 1.0 表示完全採用顯式校正 (與 Fluent / STAR-CCM+ 對齊); 預設 0.33 對歪斜網格較穩定.',
    },
    simpleConsistent: {
      label: 'SIMPLE 一致性修正 (SIMPLE consistent)',
      description:
        '啟用 SIMPLE 演算法的一致性修正 (預設開). 關閉可對齊 Fluent / STAR-CCM+ 預設. 僅外流適用.',
    },
    prefCell: {
      label: '壓力基準單元 (pRef cell)',
      description: '封閉計算域上壓力基準所在的單元索引. 如未特別指定, 保持 0.',
    },
    prefValue: {
      label: '壓力基準值 (pRef value)',
      description:
        '固定於基準單元上的壓力值. 不可壓縮採運動學壓力 (m²/s²); 未設定 gauge 基準時保持 0.',
    },
    writeFormat: {
      label: '輸出格式 (write format)',
      description:
        '結果檔輸出格式. Binary 在數百萬單元時可將每個時間步目錄縮小約 10 倍.',
      options: {
        ascii: 'ASCII（預設, 可讀）',
        binary: 'Binary（精簡）',
      },
    },
    writePrecision: {
      label: '輸出精度 (write precision)',
      description:
        '結果檔輸出的有效位數. 與其他求解器比對 Cd/Cl 時可提升至 15. 預設: 6.',
    },
    writeCompression: {
      label: '輸出壓縮 (write compression)',
      description:
        '結果檔的 zlib 壓縮開關. 適用於長時間 RAS 且磁碟空間吃緊的情況.',
    },
  },
  // 梯度格式 + 線性求解器覆寫預覽. 預設 OFF (VITE_SIMOPS_SOLVER_SCHEMES) —
  // 後端目前將這些寫死, 在 BE 契約落地前為不送出的預覽.
  schemesOverride: {
    title: '離散化與線性求解器',
    previewBanner:
      '預覽 — 後端尚未接受這些設定. 數值不會儲存或送出. 待求解器格式契約上線後即可啟用.',
    gradientGroup: '梯度控制',
    linearSolverGroup: '線性求解器',
    gradLimited: {
      label: '限制梯度',
      description:
        '對相鄰單元間的梯度加以抑制, 而非採用不限制的格式. 以少許精度換取歪斜單元上的穩定性 — 建議用於 tet 或 poly 網格.',
    },
    gradLimiterCoeff: {
      label: '限制器係數',
      description:
        '梯度抑制的強度: 0 = 不限制, 1 = 完全限制. 僅在啟用「限制梯度」時使用.',
    },
    pSolver: {
      label: '壓力求解器',
      placeholder: 'GAMG (預設)',
      description:
        '壓力方程的線性求解器. GAMG (幾何-代數多重網格) 為預設且在多數情況下最快; PCG 與 PBiCGStab 為 Krylov 類替代.',
    },
    pTolerance: { label: 'p 容差' },
    pRelTol: { label: 'p relTol' },
    uTolerance: { label: 'U 容差' },
    uRelTol: { label: 'U relTol' },
    errors: {
      limiterCoeffRange: '限制器係數必須介於 0 與 1 之間.',
      tolerancePositive: '容差必須大於 0.',
      relTolRange: '相對容差必須介於 0 與 1 之間.',
    },
  },
  simTypeFromMesh: {
    fromMesh: '已在 MeshGen 設定',
    internal: '內流',
    external: '外流',
    tooltip:
      '你選擇的網格是在 MeshGen 為此模擬類型建立的，研究會自動採用。若要執行其他類型，請在 MeshGen 建立新的網格。',
    mixed:
      '所選網格的模擬類型不一致 — 請選擇要執行的類型，或移除不相符的網格。',
  },
  simType: {
    cfd: {
      title: '計算流體力學。',
      summary: '以 k-ω SST 求解穩態不可壓縮流（速度、壓力、紊流）。',
      mesh: '網格：單一區域流體網格（四面體或六面體）。壁面邊界層膨脹 — 解析壁面需 y⁺ ≲ 1，使用壁面函數則需 y⁺ ≈ 30~300。進出口 / 壁面面片於 MeshGen 中標記。',
    },
    fea: {
      title: '有限元素分析。',
      summary: '固體力學 — 靜態負載下的應力、應變與變形。',
      mesh: '網格：僅含固體的四面體或六面體，並在接觸 / 承載面與應力集中處加密。',
    },
    cht: {
      title: '共軛熱傳。',
      summary: '將流體流動與固體熱傳導耦合 — 回報各區域溫度與峰值熱點溫度。',
      mesh: '網格：多區域四面體網格，含一個流體區域與一個或多個固體。各區域分別劃分網格並求解，熱量跨越流固界面傳遞。標記的面驅動進口、出口、固定溫度、熱通量或對流邊界條件。',
    },
  },
  form: {
    inletSweep: '進口掃掠',
    outletSweep: '出口掃掠',
    velocity: '速度',
    velocityNote:
      '沿所選方向的速度。逗號可建立掃掠 — 每個值一次執行（1, 2, 3 → 3 次執行），而非 3D 向量。',
    pressure: '壓力',
    pressureNote: '錶壓 — 0 = 環境參考（1 atm 絕對壓）',
    sweepFieldInfoAria: '掃掠欄如何生成設計點',
    sweepFieldInfo:
      '此欄如何變成設計點:\n\n• 單一值 → 以該值執行 1 次.\n• 逗號分隔的清單 → 每個值執行 1 次.\n• 多個掃掠欄 → 執行所有組合 (2 × 3 → 6 次).\n\n目前 CFD 可掃掠: 入口速度, 出口壓力, 以及 密度 ρ / 動態黏度 μ / 運動黏度 ν 三者中的兩者 (剩下一者由 ν = μ/ρ 導出).\n\n這些欄位的值就是研究預設值. 每個設計點都使用這些值, 除非該點明確覆寫. 因此在這裡修改欄位就是修改整個掃掠的預設 — 沒有另外的「另存為預設」動作.\n\n手動 DP 為掃掠後附加的獨立點, 不會加乘直積 (1 個手動 DP = 額外執行 1 次); 手動 DP 未填的欄位會沿用此處的研究預設值.',
    flowType: '流動類型',
    // 紊流模型下拉選項。工程術語 (k-ε / k-ω / SST) 保留英文以便文獻查找,
    // 前面加上自然語言名詞讓初次使用者能辨認。
    flowTypeOptions: {
      laminar: '層流 (Laminar)',
      k_epsilon: '紊流 k-ε (k-epsilon)',
      k_omega: '紊流 k-ω (k-omega)',
      k_omega_sst: '紊流 k-ω SST',
    },
    flowTypeShort: {
      laminar: '層流',
      k_epsilon: 'k-ε',
      k_omega: 'k-ω',
      k_omega_sst: 'k-ω SST',
    },
    turbulence: '紊流',
    intensity: '強度',
    intensityTooltip:
      '速度擾動與平均流動之比（u′/U）。設定初始紊流動能 k。典型值：外流 0.01~0.05，內流 0.05~0.10。',
    lengthScale: '長度尺度（m）',
    lengthScaleTooltip:
      '用於設定初始 ω 與 ε 的特徵渦尺寸。經驗法則：約幾何特徵長度（弦長、直徑）的 7%。預設為 0.1 m。',
    flowTypeDefaults: '{{label}} 預設值',
    clickToView: '· 點按檢視',
    flowTypeDefaultsCard: {
      notes: {
        laminar: '無湍流模型。適用於 Re ≲ 2,000 的內部流或低 Re 外部流。',
        k_epsilon:
          '標準 k-ε 模型。在自由流中穩健,但缺少壁函數時對壁面附近的精度不足 — 僅在 y+ 位於對數律區間 (30~300) 時使用。',
        k_omega:
          'Wilcox k-ω 模型。壁面附近的表現優於 k-ε,但對自由流的 ω 邊界值敏感。大多數外部氣動案例建議選擇 SST。',
        k_omega_sst:
          'Menter k-ω SST 模型。在邊界層採用 k-ω、於自由流採用 k-ε 混合 — 大多數外部氣動與內部流 CFD 的安全預設。可解析至壁面 (y+ ≲ 1) 或使用壁函數 (y+ ≳ 30)。',
      },
      labels: {
        maxIterations: '最大迭代次數',
        residualPU: '殘差 p / U',
        writeInterval: '寫入間隔',
        nonOrthCorrectors: '非正交修正次數',
        relaxPU: '鬆弛因子 p / U',
        turbulenceIntensity: '湍流強度',
        lengthScale: '特徵長度',
      },
      values: {
        lengthScaleHint: '使用者設定 (物體長度的 ≈ 7 %)',
      },
    },
  },
  unsupported: {
    title: '{{template}} 尚無法在 UI 中編輯。',
    body: '使用此範本的研究是透過 API 或舊版前端建立的。請在報告中檢視已儲存的設定；若要編輯，請透過上方的切換按鈕變更研究類型。',
  },
  fluidProps: {
    fluid: '流體',
    density: '密度',
    dynamicViscosity: '動態黏度',
    kinematicViscosity: '運動黏度',
    derivedFrom: '由 {{a}} 與 {{b}} 導出',
    pinDerivedTip:
      '{{field}} 為導出值。點按其他欄位的連結圖示即可改為導出該欄位。',
    pinUserDefinedTip: '{{field}} 為使用者定義。點按可將其設為導出欄位。',
    presets: {
      air: '空氣 (20 °C)',
      water: '水 (20 °C)',
      custom: '自訂',
    },
  },
  sweepField: {
    // Accessible names for the two comboboxes inside a sweep field whose
    // only content is their own current value (ENG-1733). `unitAria` is the
    // fallback for a field whose label is a ReactNode with no string form.
    unitForAria: '{{field}} 的單位',
    unitAria: '單位',
    priorForAria: '{{field}} 的先驗分布',
    modeToggleAria: '掃掠模式',
    single: '單一',
    range: '範圍',
    lowerBound: '下界',
    upperBound: '上界',
    prior: '先驗',
    priorUniform: '均勻',
    priorLogUniform: '對數均勻',
    sweepCount: '{{count}} 個值 · 掃掠（每個值各執行一次）',
    continuous: '連續，取自研究取樣',
  },
  // 掃掠軸路徑 — 用於預覽欄標題・覆寫值標籤・圖表圖例.
  // 原始路徑 (`inlet.velocity` 等) 為結構化欄位, 對使用者為術語, 改以平白名稱顯示.
  sweepPaths: {
    inletVelocity: '入口速度',
    outletPressure: '出口壓力',
    // 保留希臘符號供熟悉標記法的讀者辨識, 開頭名詞讓新讀者也能理解.
    rho: '密度 (ρ)',
    mu: '動態黏度 (μ)',
    nu: '運動黏度 (ν)',
    initialTemperature: '初始溫度',
    axisFx: 'Fx',
    axisFy: 'Fy',
    axisFz: 'Fz',
    loadVector: '{{target}} · {{axis}}',
    facePressure: '{{target}} · 壓力',
    contactFriction: '接觸 {{name}} · 摩擦',
    contactStiffness: '接觸 {{name}} · 剛性',
    contactStickSlope: '接觸 {{name}} · 黏滯斜率',
    boltPreload: '螺栓 {{name}} · 預載',
    tieTolerance: '結合 {{name}} · 位置公差',
    thermalValue: '{{target}} · 溫度 / 熱通量',
    convectionH: '{{target}} · 對流 h',
    ambientTemperature: '{{target}} · 環境溫度',
    radiationEmissivity: '{{target}} · 放射率',
    gravityMagnitude: '重力 · 大小',
    centrifugalRpm: '離心力 · RPM',
  },
  responseKeys: {
    nu: '運動黏度 (ν)',
    rho: '密度 (ρ)',
    outletVelocity: '出口速度',
    pumpingPower: '泵送功率',
    thermalResistance: '熱阻',
    pressureDrop: '壓力損失',
    inletFlowRate: '入口流量',
    outletFlowRate: '出口流量',
    // 作用力 (applied force) — CFD 表面積分所得的分量; 「力」單獨過泛,
    // 「作用力」為流體力學慣用術語. 方向由 X/Y/Z 明示; F_x 下標記法屬
    // 論文寫作層次, UI 標籤採平白版即可.
    forceX: '作用力 X',
    forceY: '作用力 Y',
    forceZ: '作用力 Z',
    hottestSolid: '最高固體溫度',
    targetMet: '達成目標',
    targetTemperature: '目標溫度',
    // Kinematic pressure = p/ρ (m²/s²). 「動壓」為 ½ρU² (Pa) 完全不同的量,
    // 「運動學壓力」才是 p/ρ 的正確譯法.
    pressureDropKinematic: '運動學壓力損失',
    lastTimeStep: '最後時間步',
    timeSteps: '時間步數',
    // OpenFOAM ExecutionTime — 求解器內部計時的 wall-clock.
    // 「求解時間」明確指涉求解器耗時, 不與作業系統 process time 混淆.
    executionTime: '求解時間',
    iterations: '迭代次數',
    // 「計算已收斂」— 「收斂」在日常中文可讀為「內斂 / 節制」,加「計算」前綴
    // 明確為數值收斂 (殘差降至門檻以下).
    converged: '計算已收斂',
    // 「求解發散」— 「發散」在物理中亦可指擴散 (diffuse), 加「求解」前綴
    // 明確為數值發散 (殘差爆炸或 NaN), 與 diffusion / 擴散 區隔.
    divergenceDetected: '偵測到求解發散',
    hasHeatSource: '含熱源',
    totalHeatFlux: '總熱通量',
    peakHeatFlux: '峰值熱通量',
    interface: '介面',
    volume: '體積',
    area: '面積',
    // ENG-1952 逐面 patch 界面明細。濕潤面積、壁溫，以及膜係數所除的壁→主流 ΔT。
    // 各區域的材料性質。是熱導率而非導電率，是發熱功率而非電力。
    // 線上欄位名 (`conductivity_w_m_k`, `declared_power_w`) 兩種都讀得通，
    // 因此由標籤講清楚。
    thermalConductivity: '熱導率',
    specificHeat: '比熱',
    declaredHeatLoad: '宣告熱源功率',
    volumeAveragedTemp: '體積平均溫度',
    initialTemp: '初始溫度',
    perPatchArea: '逐面 patch 面積',
    perPatchWallTemp: '逐面 patch 壁溫',
    perPatchWallBulkDt: '逐面 patch 壁→主流 ΔT',
    bulkTemp: '主流溫度',
    totalHeatFluxSolidSide: '總熱通量 (固體側)',
    interfaceDisagreement: '界面不一致',
    // 能量收支區塊: 投入熱與移除熱，以及兩者的差。
    energyBalance: '能量收支',
    heatInput: '投入熱',
    heatRemoved: '移除熱',
    heatBalanceTolerance: '熱平衡容差',
    // thermal_transient DP 短名單欄位 (ENG-3002 / TH-6)。
    peakTemperature: '峰值溫度',
    peakTime: '峰值時間',
    peakBody: '峰值部位',
    timeReached: '到達時間',
    nIncrements: '增量次數',
    nFrames: '影格數',
    bodyTemperatures: '體積溫度',
    bodyPeakTemperatures: '體積峰值溫度',
    surfaceFluxesW: '表面熱通量',
    temperatureBounds: '溫度上下限',
    energyIn: '輸入能量',
    energyOut: '輸出能量',
    storedEnergyChange: '儲能變化',
    energyImbalance: '能量不平衡',
    imbalance: '不平衡',
    imbalancePct: '不平衡',
    verdict: '判定',
    perPatch: '逐面 patch',
    solidPerPatch: '逐面 patch (固體側)',
    peakFluxPatch: '峰值熱通量 patch',
    hottestSolidRegion: '最高溫固體',
    convergence: '收斂性',
    finalResiduals: '最終殘差',
    fluid: '流體',
    solid: '固體',
    limiterClamps: '限制器鉗制',
    velocityCells: '速度單元',
    velocityCellsPct: '速度單元 (%)',
    temperatureLowerCells: '溫度單元 (下限)',
    temperatureUpperCells: '溫度單元 (上限)',
    temperatureLowerCellsPct: '溫度單元 (下限, %)',
    temperatureUpperCellsPct: '溫度單元 (上限, %)',
    temperatureUnlimitedMaxK: '未鉗制最高溫',
    temperatureUnlimitedMinK: '未鉗制最低溫',
    temperatureUnlimitedMax: '未鉗制最高溫',
    temperatureUnlimitedMin: '未鉗制最低溫',
    coolantDeltaT: '冷媒 ΔT',
    coolantMassFlow: '冷媒質量流量',
    coolantMassImbalance: '冷媒質量不平衡',
    limitTemperatureMax: '溫度夾持上限',
    simError: '模擬錯誤',
    detail: '詳細',
    statMin: '最小',
    statAvg: '平均',
    statMax: '最大',
    // 平白式 (溫度/流速 + 統計量) 取代方程式符號 T/U — 中文 UI 直接顯示
    // 概念詞比顯示羅馬字符號 T 更易讀. 論文寫作仍可用 T_min / U_max 記法,
    // 但 UI 標籤採自然語言為佳.
    tempStat: '溫度{{stat}}',
    velMax: '流速最大',
    // 求解場以圓括號標示 (U/p/k/ω/ε/h). R 記號屬 CFD 論文層次的公式標註,
    // UI 標籤採平白版即可.
    finalResidual: '最終殘差 ({{field}})',
    initialResidual: '初始殘差 ({{field}})',
    // FEA (CalculiX 結構靜力分析) 的結果欄標籤.「von Mises」是應力評估準則的
    // 專有名稱, 各語言皆保留原文. 單位 (MPa / mm) 由欄位端附加, 此處僅為量的
    // 名稱.
    maxVonMises: '最大 von Mises 應力',
    maxVonMisesNode: '最大 von Mises 節點',
    maxPrincipal: '最大主應力',
    maxPrincipalNode: '最大主應力節點',
    minPrincipal: '最小主應力',
    minPrincipalNode: '最小主應力節點',
    maxShear: '最大剪應力',
    materialYield: '材料降伏強度',
    materialUltimate: '材料極限強度',
    maxDisplacement: '最大位移',
    maxDisplacementNode: '最大位移節點',
    safetyFactorYield: '安全係數 (降伏)',
    safetyFactorUltimate: '安全係數 (極限)',
    // 非數值的 FEA 純量: 合格判定與所用材料.
    assessment: '評定',
    materialName: '材料',
    // external_flow 與流動軸無關的壁面載荷分解. 力為壓力 (法向) / 黏性
    // (切向) 牽引力的大小; 壁面壓力為物體壁面的錶壓極值. 單位 (N / Pa)
    // 顯示於標題; 比值為無因次.
    forceNormalMag: '法向力',
    forceTangentialMag: '切向力',
    normalTangentialRatio: '法向 / 切向 比',
    wallPressureMin: '壁面壓力 (最小)',
    wallPressureMax: '壁面壓力 (最大)',
    // 逐軸壁面牽引力分解 — `_mag` 純量的向量兄弟項.
    // 壓力力 = 法向分量 (爆裂 / 環向驅動);
    // 黏性力 = 切向分量 (表面摩擦).
    forcePressureX: '壓力 X',
    forcePressureY: '壓力 Y',
    forcePressureZ: '壓力 Z',
    forceViscousX: '黏性力 X',
    forceViscousY: '黏性力 Y',
    forceViscousZ: '黏性力 Z',
    // 入口平均速度 — 收斂後入口面積加權平均.
    inletVelocityAvg: '入口速度',
    // 「質量不平衡」— |入口 − 出口| / max, 為無因次的守恆誤差.
    massImbalanceFrac: '質量不平衡',
    // 求解器偵測到的非物理狀態 (負體積 / 非有限殘差 / BC 不良).
    solutionUnphysical: '非物理解',
    // 力係數 (external_flow, 僅在 sim_params.force_coeffs 設定時輸出).
    // 皆為無因次 — 標籤不附單位.
    cd: '阻力係數 (C_D)',
    cl: '升力係數 (C_L)',
    cmPitch: '俯仰力矩係數 (C_M)',
    clCdRatio: '升阻比 (L/D)',
    copFracLref: '壓力中心比 (l_ref)',
    cdBand: 'C_D 穩定帶寬',
    clBand: 'C_L 穩定帶寬',
    cdDrift: 'C_D 漂移',
    clDrift: 'C_L 漂移',
    // 域內流體溫度聚合 (CFD + 熱).
    temperatureMin: '溫度 (最小)',
    temperatureAvg: '溫度 (平均)',
    temperatureMax: '溫度 (最大)',
    // 壁面 y⁺ 聚合值 (external_flow 解析器). 無因次.
    yplusMin: 'y⁺ 最小',
    yplusMean: 'y⁺ 平均',
    yplusMax: 'y⁺ 最大',
    // 質量與慣性（FEA 質量特性）。單位（kg / kg·m² / m）由
    // responseKeyUnit 附加於欄位標題。
    mass: '質量',
    inertiaIxx: '慣性矩 Ixx',
    inertiaIyy: '慣性矩 Iyy',
    inertiaIzz: '慣性矩 Izz',
    inertiaIxy: '慣性矩 Ixy',
    inertiaIxz: '慣性矩 Ixz',
    inertiaIyz: '慣性矩 Iyz',
    radiusOfGyrationX: '迴轉半徑 X',
    radiusOfGyrationY: '迴轉半徑 Y',
    radiusOfGyrationZ: '迴轉半徑 Z',
    yplusFracBelow5: 'y⁺ 面積比 (< 5)',
    yplusFrac5To30: 'y⁺ 面積比 (5–30)',
    yplusFrac30To100: 'y⁺ 面積比 (30–100)',
    yplusFracAbove100: 'y⁺ 面積比 (> 100)',
    cumulativeContinuity: '累積連續性',
    solverFailed: '求解器失敗',
    velocityRunaway: '速度發散',
    singularMatrixDetected: '壓力矩陣奇異',
    hintBcIc: '提示：檢查邊界／初始條件',
    hintMeshQuality: '提示：檢查網格品質',
    hintTurbulence: '提示：檢查紊流模型',
    exitCode: '結束代碼',
    maxPLinearIters: '壓力求解器最大疊代數',
    divergenceOnsetStep: '發散起始步',
    firstDivergedField: '最先發散的場',
    solverMpiRanks: '求解器 MPI 分割數',
    totalPressureDropPa: '總壓損失',
    totalPressureDropKinematic: '總壓損失 (運動學)',
    zeta0: 'ζ₀ (總壓損失係數)',
    zetaP: 'ζₚ (靜壓損失係數)',
    velocity: '速度',
    pressure: '壓力',
    density: '密度',
    temperature: '溫度',
    angleOfAttackDeg: '迎角 α (度)',
    sideslipDeg: '側滑角 β (度)',
    inlet: '入口',
    outlet: '出口',
  },
  fieldNames: {
    displacement: '位移量值',
    displacement_x: 'x 向位移',
    displacement_y: 'y 向位移',
    displacement_z: 'z 向位移',
    von_mises: 'von Mises 應力',
    max_principal: '最大主應力',
    min_principal: '最小主應力',
    max_shear: '最大剪應力',
    temperature: '溫度',
    U: '速度',
    Ux: '速度 x',
    Uy: '速度 y',
    Uz: '速度 z',
    p: '壓力',
    p_rgh: '修正壓力',
    T: '溫度',
    h: '焓',
    k: '紊流動能',
    epsilon: '消散率',
    omega: '比消散率',
    nut: '紊流黏度',
    nuTilda: '修正紊流黏度',
    alphat: '紊流熱擴散率',
    nut_over_nu: '黏度比',
    rho: '密度',
    phi: '通量',
    wallShearStress: '壁面剪應力',
    vorticity: '渦度',
  },
  fieldTooltips: {
    von_mises:
      '等效拉應力，延性降伏判定所比較的純量。就構成而言不帶正負號：純壓縮的零件與同量值的純拉伸讀數相同，而純剪狀態會高估 √3 倍。當荷載方向重要時，請併同主應力一起判讀。',
    max_principal:
      '最大主應力 σ1。帶正負號，正值為拉伸，用以判斷尖峰是在張開裂縫還是閉合裂縫，也是脆性材料的評定依據。',
    min_principal:
      '最小主應力 σ3。帶正負號；最負的點即零件中受壓最劇之處。與 σ1 併讀可區分承壓接觸與拉伸熱點。',
    max_shear:
      '任一平面上的最大剪應力，即 Tresca 的 (σ1 − σ3) / 2。主導滑動而非伸長的螺栓或黏接接頭，也是規範要求採用 Tresca 而非 von Mises 時的基礎。',
    // Mass & inertia (FEA). The frame is repeated on every tensor
    // component deliberately — the backend does not emit the centre of
    // mass, so this is the only place it is stated.
    mass: '總質量 — 各實體的 CAD 體積乘以其指定材料密度後的總和。已排除擷取出的流體空腔。',
    inertiaIxx: '繞 x 軸的慣性矩（相對於組件質心，全域網格座標系）。',
    inertiaIyy: '繞 y 軸的慣性矩（相對於組件質心，全域網格座標系）。',
    inertiaIzz: '繞 z 軸的慣性矩（相對於組件質心，全域網格座標系）。',
    inertiaIxy:
      'xy 慣性積（相對於組件質心，全域網格座標系）。不為零表示全域軸並非主軸。',
    inertiaIxz: 'xz 慣性積（相對於組件質心，全域網格座標系）。',
    inertiaIyz: 'yz 慣性積（相對於組件質心，全域網格座標系）。',
    radiusOfGyrationX: '繞 x 軸的迴轉半徑 — √(Ixx/m)，相對於全域軸而非主軸。',
    radiusOfGyrationY: '繞 y 軸的迴轉半徑 — √(Iyy/m)，相對於全域軸而非主軸。',
    radiusOfGyrationZ: '繞 z 軸的迴轉半徑 — √(Izz/m)，相對於全域軸而非主軸。',
    p_rgh:
      '修正壓力 p − ρgh (扣除靜壓水頭) — CHT 求解器所解的量. 為運動學形式 (p/ρ, m²/s²); 切換單位即可透過 ρ 讀為絕對值 Pa/psi. 殘差反映連續性 / 質量守恆的收斂狀況.',
    p: '靜壓 — 不可壓縮 OpenFOAM 以運動學形式 (p/ρ, m²/s²) 求解; 切換單位即可透過 ρ 讀為絕對值 Pa/psi. 殘差反映連續性 / 質量守恆的收斂狀況.',
    U: '速度向量 — 動量方程殘差 (三分量的合成大小).',
    Ux: '速度 x 分量 — 動量方程殘差.',
    Uy: '速度 y 分量 — 動量方程殘差.',
    Uz: '速度 z 分量 — 動量方程殘差.',
    h: '焓 — 能量方程殘差 (CHT 固-流體溫度耦合).',
    k: '紊流動能 — k-ε / k-ω 模型殘差.',
    omega: '比消散率 ω — k-ω / SST 模型殘差 (渦黏性尺度).',
    epsilon: '紊流耗散率 ε — k-ε 模型殘差.',
    nut: '紊流渦黏性 νₜ — 導出場; 殘差反映紊流封閉的穩定性.',
    alphat: '紊流熱擴散率 αₜ — 導出場, 將紊流耦合至能量方程.',
    temperature: '共軛熱傳求解的穩態溫度場 — 流體與固體區域共用同一尺度.',
    pressure_drop_pa: '整個計算域的靜壓損失 (進口 − 出口), 絕對值 Pa.',
    pumping_power_w:
      '推動冷卻液通過計算域的理想液壓功率：壓降 × 體積流量 (Δp × ṁ/ρ)。不含幫浦效率與馬達損失。',
    pressure_drop_kinematic:
      '同一壓力損失以運動學形式表達 (Δp/ρ, m²/s²) — 即絕對值 Pa 除以流體密度 ρ.',
    tempStat: '此區域內的穩態溫度極值 — 收斂後溫度場的最小 / 平均 / 最大值.',
    velMax: '此區域收斂時的最大速度大小.',
    force_normal_mag:
      '物體壁面上壓力 (法向) 力總和的大小. 與流動軸無關 — 不需選擇 Cx/Cy/Cz 分量即可作為壁面載荷的直接讀數.',
    force_tangential_mag:
      '物體壁面上黏性 (切向) 力總和的大小 — 表面摩擦分量. 與流動軸無關.',
    normal_tangential_ratio:
      '法向 (壓力) ÷ 切向 (黏性) 壁面力. 高 = 壓力主導的載荷; 低 = 摩擦主導. 無因次; 切向力為零時為 null.',
    wall_pressure_min_pa:
      '物體壁面上錶壓的最小值, 絕對值 Pa. 可作為結構分析的壁面載荷輸入.',
    wall_pressure_max_pa:
      '物體壁面上錶壓的最大值, 絕對值 Pa. 可作為結構分析的峰值壁面載荷輸入.',
    force_pressure_x:
      '物體壁面上壓力 (法向) 力的 X 分量. 所有壁面上 p·n 的總和.',
    force_pressure_y: '物體壁面上壓力 (法向) 力的 Y 分量.',
    force_pressure_z: '物體壁面上壓力 (法向) 力的 Z 分量.',
    force_viscous_x: '物體壁面上黏性 (切向) 力的 X 分量 — 表面摩擦貢獻.',
    force_viscous_y: '物體壁面上黏性 (切向) 力的 Y 分量.',
    force_viscous_z: '物體壁面上黏性 (切向) 力的 Z 分量.',
    inlet_flow_rate_m3s:
      '收斂時通過入口面的體積流率. 符號：流入場域為正. 應與出口在 Mass Imbalance Frac 範圍內相符.',
    outlet_flow_rate_m3s: '收斂時通過出口面的體積流率. 符號：流出場域為正.',
    outlet_velocity_avg_ms: '收斂時出口面上以面積加權的平均速度大小.',
    inlet_velocity_avg_ms:
      '收斂時入口面上以面積加權的平均速度大小 — 應與研究入口速度 BC 一致.',
    mass_imbalance_frac:
      '|inlet − outlet| / max(|inlet|, |outlet|) — 收斂時的質量守恆分數誤差. 通常 1e-4 以下; 超過 1e-2 表示連續方程未完全閉合.',
    time_step_count:
      '在達到殘差目標或最大迭代上限之前, 求解器實際執行的迭代 (或暫態情況下的時間步) 總數.',
    last_time_step:
      '求解器寫出的最終迭代計數值. 正常執行時與總步數相同; 若求解器中斷則可能不同.',
    execution_time_s:
      '求解器迭代所耗的實際時間 (秒). 不含案例設置, 網格轉換, 及結果擷取.',
    solution_unphysical:
      '當求解器在收斂場中偵測到非物理值時為 true — 負體積, 非有限殘差, 或不適當的 BC.',
    divergence_detected:
      '當殘差在迭代中不縮小而放大時為 true — 求解器未收斂, 結果不可信.',
    cd: '阻力係數 (C_D) — 沿流動方向之壓力 + 黏性力, 以 ½·ρ·U²·A_ref 正規化. 無因次.',
    cl: '升力係數 (C_L) — 垂直流動方向之壓力 + 黏性力, 以 ½·ρ·U²·A_ref 正規化. 無因次.',
    cm_pitch:
      '俯仰力矩係數 (C_M) — 繞所設定俯仰軸 (垂直於流動軸) 的力矩, 以 ½·ρ·U²·A_ref·l_ref 正規化. 符號依右手定則: 正 C_M = 從 +俯仰軸方向看為逆時針旋轉, 負 = 順時針. 對應到機頭上仰 / 下俯要看選了 XYZ 哪一軸為俯仰軸, 以及物體在計算域中的擺放方向. 無因次.',
    cl_cd_ratio: '升阻比 — C_L / C_D. 氣動效率指標. 無因次.',
    cop_frac_lref:
      '壓力中心 (CoP) — 沿基準弦方向, 壓力分布可視為一集中力作用的位置. 從力矩基準點沿俯仰軸方向 (與流動與升力軸垂直) 量測, 以基準弦 (l_ref) 的比例表示. 0 = 位於力矩基準點, 0.25 = 1/4 弦位置 (薄翼理論之空力中心), 1.0 = 一個弦長下游. 無因次. 空力力 / 力矩為 0 時為 null.',
    cd_band:
      '最終反覆窗口內 C_D 變動的半寬 — 求解結束時阻力仍在震盪的幅度. 接近零 = 已穩定; 較大 = 信任 C_D 前應增加反覆次數.',
    cl_band:
      '最終反覆窗口內 C_L 變動的半寬 — 求解結束時升力仍在震盪的幅度. 接近零 = 已穩定; 較大 = 信任 C_L 前應增加反覆次數.',
    temperature_min: '域內穩態流體溫度的最小值 (K).',
    temperature_avg: '收斂時的體積加權平均流體溫度 (K).',
    temperature_max: '域內穩態流體溫度的最大值 (K).',
    yplus_min:
      '收斂時物體壁面上 y⁺ 之最小值. 小於 5 表示已解析黏性底層 (需低 Re 模型); 若使用壁面函數而低於 30 則表示解析不足.',
    yplus_mean:
      '收斂時物體壁面上以面積加權之平均 y⁺. 用於快速檢查近壁網格尺寸是否合理.',
    yplus_max:
      '收斂時物體壁面上 y⁺ 之最大值. 使用壁面函數時超過 300 表示對數律超出有效範圍, 剪應力與熱傳將偏離.',
    yplus_frac_below_5:
      '收斂時 y⁺ < 5 之濡濕壁面面積比 — 黏性底層帶. 使用壁面函數時若此帶偏高, 表示近壁網格對該模型過度解析; 低 Re / 壁面解析模型則希望此帶為主.',
    yplus_frac_5_to_30:
      '收斂時 5 ≤ y⁺ < 30 之濡濕壁面面積比 — 緩衝層, 壁面函數與低 Re 解析 BL 皆不適用. 若此帶有明顯面積, 剪應力與熱傳將落在模型空窗中; 應加密或粗化近壁網格使其離開此帶.',
    yplus_frac_30_to_100:
      '收斂時 30 ≤ y⁺ ≤ 100 之濡濕壁面面積比 — 標準對數律壁面函數之最佳範圍. 使用壁面函數時此值越高代表近壁網格尺寸越健全.',
    yplus_frac_above_100:
      '收斂時 y⁺ > 100 之濡濕壁面面積比 — 超出對數律有效範圍. 使用壁面函數時若此帶有明顯面積, 剪應力與熱傳將於模型範圍外評估, 下游阻力 / 升力 / 熱通量不可信.',
    solver_failed:
      '求解器以非零狀態結束或被強制終止時為真。與失敗橫幅表達相同的事，但是重試邏輯可據以分支的機器可讀旗標。',
    velocity_runaway:
      '執行停止前速度量值無界成長時為真。用以區分真正發散的動量求解與僅是耗盡疊代次數的求解。',
    singular_matrix_detected:
      'OpenFOAM 回報矩陣奇異時為真。在封閉域中這幾乎總是表示未釘住壓力參考點，壓力場沒有絕對值可解。',
    hint_bc_ic:
      '當失敗型態指向邊界或初始條件時設定：壓力矩陣奇異、連續方程式中止，或在十次疊代內就結束的執行。',
    hint_mesh_quality:
      '當任一步驟中壓力求解器需要 50 次以上疊代時設定（單一步驟符合即成立），指向條件不良的網格：高非正交性或極端長寬比。',
    hint_turbulence:
      '當紊流場（k、ω 或 ε）比壓力或速度更早變成 NaN 時設定，指向紊流模型而非動量求解。層流不求解這些場，因此永遠不會設定。',
    exit_code:
      '求解器行程的結束狀態。若容器是被強制終止（逾時或記憶體不足）則不存在。',
    max_p_linear_iters:
      '單一步驟中壓力線性求解器所需的最高疊代次數。持續偏高正是網格品質提示的判斷依據。',
    divergence_onset_step:
      '殘差由下降轉為上升的第一個步驟。未偵測到發散時為 null。',
    first_diverged_field:
      '最先發散的場。最先崩壞的場通常就是要修的地方，紊流場與壓力場指向不同的成因。',
    cumulative_continuity:
      '跨迭代之累積質量守恆誤差. 應與壓力殘差同步遞減; 若持平或上升, 表示連續性尚未完全閉合 (邊界條件不一致, 網格非正交性, 或壓力求解鬆弛不足).',
    solver_mpi_ranks:
      '求解器分割區域所用之 MPI 工作者數量. 僅為並行拓撲, 不影響物理; 於失敗執行中排查分割是否為主因時有用.',
    sim_error_yplus_min:
      '被標記的計算中壁面 y+ 的最小值，僅供參考。它只是一個面 (常位於角落或停滯點)，本身不決定是否標記。y+ 下限的判定依據壁面面積比例與紊流模型：任何模型下壁面超過 10% 落在 y+ 5–30 緩衝層即標記；低於 y+ 5 超過 10% 只在使用對數律壁面函數的 k-ε 時標記。網格達 y+ ≈ 1 的 k-ω SST 是解析黏性底層的壁面，不是錯誤。此判定之前的計算僅依這個單一數值就被標記。',
    // ---- CHT 結果列的工具提示 ----
    chip_t_max_k:
      '所有被標記為熱源的固體區域中的最高溫度。決定與目標溫度比較的合格/不合格徽章。',
    target_temperature_k:
      '使用者設定的溫度上限。為 null 時不顯示合格/不合格判定 — 硬編碼的 70 °C 上限會讓非電子案例誤過關。',
    target_met:
      'chip_t_max_k 是否保持在 target_temperature_k 之下。未設目標時為 null。',
    coolant_mass_flow_kg_s:
      '收斂時流體區域的冷媒質量流量。較新的求解器執行才會輸出，舊執行為空白。',
    coolant_delta_t_k:
      '通過流體區域的冷媒焓升 (出口溫度 − 入口溫度)。與 ṁ · c_p 結合可得到冷媒實際帶走的熱功率。',
    coolant_mass_imbalance_kg_s:
      '求解器回報的冷媒入口與出口質量不平衡。收斂執行應為 ~0；非零表示質量平衡未在捨入誤差內閉合。',
    total_heat_flux_w:
      '本次執行所有流體 ↔ 固體介面通過的瓦數總和。每個介面為一對冷媒 ↔ 固體 (coolant ↔ solid_0, coolant ↔ solid_1, …), 此處的數值為所有這些介面的總和。儲存值以流入固體的熱為正, 因此固體加熱冷媒的正常冷卻方向會是負值; 冷媒獲得的熱量即此數值的相反數。當本次執行有記錄時, 逐介面拆分會顯示在區域圖上; 也可在一致性檢查面板與宣告熱功率比對。',
    peak_heat_flux_w_m2:
      '流體 ↔ 固體介面上任一位置的最大局部熱通量。高值標示可能需要細分網格的熱點。若本次執行有記錄, 峰值所在的介面名稱會顯示在區域圖上。',
    interfacePerPatch:
      '通過單一介面的瓦數 (儲存值)。正 = 熱流入該介面的固體側 (固體 ↔ 固體介面則為第一個命名的區域)。固體將熱傳給冷媒的正常冷卻方向為負值; 冷媒介面上的正值表示冷媒正在加熱該固體。',
    t_min_k: '收斂時此區域內的最低溫度。',
    t_avg_k: '收斂時此區域內的體積平均溫度。',
    t_max_k: '收斂時此區域內的最高溫度。',
    u_max_m_s: '收斂時此區域內的最大速度量值。',
    iterations_run:
      '求解器執行的 SIMPLE 迭代次數。用盡迭代預算仍未收斂表示此執行應視為快照而非穩態解。',
    converged: '殘差是否在迭代預算內降至設定容差以下。',
    velocity_cells:
      '最終迭代時速度限制器夾持的單元數。非零表示求解器積極壓制 U 以維持執行 — 下游量請視為指示性，直到夾持區域重新網格化或以更好的方式驅動。',
    velocity_cells_pct:
      '最終迭代時速度限制器夾持的流體網格百分比。> 0.1 % 表示執行在求解器不得不約束的場上收斂。',
    temperature_lower_cells:
      '溫度下限限制器夾持的單元數。非零表示某處 T 落到安全下限以下，必須拉升。',
    temperature_upper_cells:
      '溫度上限限制器夾持的單元數。非零表示某處 T 超過安全上限，必須壓低。',
    temperature_lower_cells_pct: '溫度下限限制器夾持的單元百分比。',
    temperature_upper_cells_pct: '溫度上限限制器夾持的單元百分比。',
    temperature_unlimited_max_k:
      '任何夾持啟動前求解器觀察到的最高溫度。與夾持上限之間的差距越大，表示求解器越用力壓制場。',
    temperature_unlimited_min_k: '任何夾持啟動前求解器觀察到的最低溫度。',
    limit_temperature_max:
      '溫度限制器設定的上限。超過此值的單元在每次迭代都被重設為此值。',
    n_increments:
      'CalculiX 到達週期時間所走的物理時間增量次數。每個增量是熱傳步驟內的一次 Δt 前進。',
    n_frames:
      '寫入結果時間軸的溫度影格數。由輸出間隔決定 — 當間隔能整除週期時，大約是 週期時間 ÷ 間隔 + 1。',
    time_reached:
      '求解器實際到達的物理時間。完成的執行會等於週期時間；提前停止時會較短。',
    time_reached_s:
      '求解器實際到達的物理時間。完成的執行會等於週期時間；提前停止時會較短。',
    surface_fluxes_w:
      '固體側的面熱通量 (W)，依執行保存的符號：負值加熱固體；正值冷卻固體。熱平衡卡片會翻轉符號，讓紅色晶片表示加熱。',
    peak_temperature_K:
      '整個時段固體內出現過的最高溫度 — 不只是最後一幀。峰值時間與峰值部位標出何時、何處。',
    energy_in_j:
      '時段內進入固體的熱能 (∫Q_in·dt)，由各增分邊界面熱率積分而來。',
    energy_out_j:
      '時段內離開固體的熱能 (∫Q_out·dt)，由各增分邊界面熱率積分而來。',
    stored_energy_change_j:
      '時段內固體儲存熱能的變化 (ρ·c_p·∫V ΔT)。與 ∫Q_in、∫Q_out 一起閉合能量帳 — 與最後一步面積分的網格解析檢查不是同一件事。',
    energy_imbalance_j:
      '能量帳殘差：∫Q_in − ∫Q_out − ΔE_stored。數值偏大表示時段帳本未閉合（仍依賴還原梯度的面可能因網格解析拉開帳本）。',
  },
  cht: {
    // ENG-1912 — 手算錨點 + 六軸雷達讀取的宣告值，不會傳給求解器。
    // 輸入 0 或負值時顯示。`SimGeometry` 兩個欄位都宣告 gt=0，直接送出
    // 只會得到一個看不出是哪個欄位造成的 422。
    mustBePositive: '必須大於零。',
    handCalcGeometry: '手算幾何',
    // 符號與單位在 JSX 以 normal-case 組成（RowLabel 會把 D_h (m) 變成 D_H (M)）。
    hydraulicDiameter: '水力直徑',
    hydraulicDiameterInfo:
      '冷卻流道的水力直徑 (濕潤斷面的 4·A/P)。用於初始化報告手算面板的 D_h 欄位，並確立 Nu 與 j 係數的雷達軸。非求解器輸入，留空不會改變此次執行的結果。',
    characteristicLength: '特徵長度',
    characteristicLengthInfo:
      '熱在固體內傳導的距離，通常為壁厚或底板厚度。用於初始化報告手算面板的 L 欄位，並確立 Bi 雷達軸。非求解器輸入。',
    fluid: '流體',
    fluidMaterials: {
      water_20c: '水 (20 °C)',
      egw_50_50_25c: 'EGW 50/50 (25 °C)',
      pg_25_25c: 'PG 25 (25 °C)',
      air_20c: '空氣 (20 °C)',
    },
    fluidMaterialsFull: {
      egw_50_50_25c: 'Ethylene glycol–water 50/50 mix',
      pg_25_25c: 'Propylene glycol–water 25% mix',
    },
    syncAria: '將流體屬性同步至進口溫度',
    syncUnsupported:
      '{{material}} 的溫度插值屬性即將推出。目前僅水具有溫度對照表。',
    syncNeedsInletTemp: '請先設定進口溫度 — 同步會據此查詢操作點的水屬性。',
    syncCompute:
      '計算目前進口溫度（{{kelvin}} K / {{celsius}} °C）下水的密度、黏度、Cp 與 k，並寫入為覆寫值。有效範圍 0~100 °C；超出範圍時取端點值。',
    density: '密度',
    densityInfo: '單位體積的質量。輸入值以覆寫預設的預設值。',
    kinematicViscosity: '運動黏度',
    kinematicViscosityInfo: '運動黏度（ν = μ/ρ）。接受如 1.5e-5 的科學記號。',
    specificHeat: '比熱',
    specificHeatInfo: '定壓比熱。將 1 kg 流體升高 1 K 所需的能量。',
    thermalConductivity: '熱傳導係數',
    thermalConductivityInfo:
      '流體傳導熱的能力。下方的普朗特數由此值與上方三個欄位推算而得。',
    prandtlTabulated:
      '未使用 — 物性以表格提供，因此案例檔直接帶 k，沒有 Pr 欄位。',
    prandtlDerived: '由 ρ、ν、Cp、k 推算',
    prandtlPinned:
      '此案例為固定值。上方的 k 由此推算，因此變更 ρ、ν 或 Cp 都會連帶改變 k。輸入熱傳導係數即可接手。',
    inlet: '進口',
    velocity: '速度',
    velocityInfo: '沿流動軸的進口速度大小。',
    inletTemperature: '進口溫度',
    inletTemperatureInfo: '進入計算域的流體溫度。',
    solidRegion: '固體區域',
    material: '材料',
    materialInfo: '選擇固體材料 — 下方的密度、導熱係數與比熱來自材料庫。',
    selectMaterial: '選擇材料…',
    heatSource: '熱源',
    heatSourceInfo:
      '此物體如何散熱。總功率是規格書上提供的數值，功率密度則是每立方公尺的瓦數。「僅熱傳導」明確表示此物體不發熱，與未指定不同。',
    heatSourceKind: {
      undeclared: '未指定',
      none: '僅熱傳導（不發熱）',
      totalPower: '總功率（W）',
      powerDensity: '功率密度（W/m³）',
    },
    totalPower: '總功率',
    totalPowerNote: '求解時會除以此區域的網格體積，因此不會與網格產生偏差。',
    volumetricHeatSource: '體積熱源',
    volumetricHeatSourceNote: '整個區域的均勻功率密度。',
    egValue: '例如 {{value}}',
    solidRegions: '固體區域',
    noSolidRegionsTitle: '未偵測到固體區域',
    noSolidRegionsBodyPre:
      'CHT 至少需要一個固體區域。請在 Mesh 步驟中分類您的 CAD 物體 — 物體角色會流入',
    noSolidRegionsBodyPost: '並在此處填入區域清單。',
    solidFaceBcs: '固體面邊界條件',
    loadingMeshPatches: '正在載入網格面片…',
    noSolidFacesTitle: '尚未標記固體側面',
    noSolidFacesBody:
      '在 Mesh 步驟（邊界指定）中標記固體表面，以在此處指定各面的熱邊界條件。流體進出口面不會出現在此清單中 — 它們在上方控制。流固界面面片由求解器自動連接。',
    facesCount: '{{count}} 個面',
    faceBcKindInfo:
      'Adiabatic = 完全絕熱面（無熱通量）。Fixed Temperature = 表面維持在目標溫度 T。Convection = 透過對流係數 h 與環境進行熱交換。',
    bcKind: {
      adiabatic: '絕熱',
      fixedTemperature: '固定溫度',
      convection: '對流',
    },
    temperature: '溫度',
    temperatureInfo: '表面固定維持的溫度值。',
    convectionCoefficient: '對流係數',
    convectionCoefficientInfo:
      '熱傳係數 h。自然對流空氣 ~5，強制對流空氣 ~50，水 ~1000+，沸騰 ~10k+。',
    ambientTemperature: '環境溫度',
    ambientTemperatureInfo: '遠離表面的自由流溫度。',
    adiabaticNote: '此面無熱通量 — 完全絕熱。',
    flowType: '流動類型',
    flowTypeInfo:
      '紊流模型。k-ω SST 解析邊界層（需 y+ ≲ 5 網格）；k-ε / k-ω 使用壁面函數（y+ 30~300）；laminar 適用於低雷諾數流（Re ≲ 2000）。',
    flowTypeLaminar: '層流',
    flowTypeKEpsilon: 'k-ε（標準）',
    flowTypeKOmega: 'k-ω',
    flowTypeKOmegaSst: 'k-ω SST',
    turbulence: '紊流',
    intensity: '強度',
    intensityTooltip:
      '速度擾動與平均流動之比（u′/U）。設定初始紊流動能 k。典型值：外流 0.01~0.05，內流 0.05~0.10。',
    lengthScale: '長度尺度（m）',
    lengthScaleTooltip:
      '用於設定初始 ω 與 ε 的特徵渦尺寸。經驗法則：約幾何特徵長度（弦長、直徑、翼展）的 7~10%。預設為 0.1 m。',
    convergenceCriteria: '收斂準則',
    maxIterations: '最大迭代數',
    maxIterationsInfo:
      '最大求解器迭代數。留空則使用紊流模型的預設值（層流：1500，RAS：2000）。',
    residualFluid: '殘差 {{key}}',
    residualFluidInfo: '{{key}} 的收斂目標。越低越嚴格；典型值 1e-4 至 1e-6。',
    residualSolid: '殘差 {{key}}（固體）',
    residualSolidInfo:
      '固體區域焓值（固體能量方程式實際求解的場）的收斂目標。熱傳導通常比流體場收斂得更緊。',
    solverSettings: '求解器設定',
    moreOverridesTitle: '格式・壁函數・輸出',
    writeInterval: '寫入間隔',
    writeIntervalInfo:
      '解場快照之間的迭代間隔。越小 = 幀數越多、佔用磁碟越多。',
    relaxU: '鬆弛 U',
    relaxUInfo: '速度的欠鬆弛因子。越低 = 越穩定、收斂越慢。',
    relaxP: '鬆弛 P',
    relaxPInfo:
      '壓力的欠鬆弛因子。留空則使用紊流模型的預設值（層流：0.3，RAS：0.2）。',
    relaxH: '流體能量鬆弛因子',
    limitVelocityFactor: '速度限制係數',
    limitVelocityFactorInfo:
      '以入口速度倍數表示的速度上限（limitVelocity fvOption）。單一劣質網格的局部尖峰不應摧毀整體良好的解。設為 0 可停用限制器。',
    limitTemperatureMin: '溫度限制（下限）',
    limitTemperatureMinInfo:
      '流體溫度下限（limitTemperature fvOption）。內部以克氏溫標儲存，可在單位選單切換 °C / °F。留空時會依入口溫度推導範圍，而非停用限制器。僅覆寫單側可能與推導的另一側顛倒，因此請同時設定下限與上限。',
    limitTemperatureMax: '溫度限制（上限）',
    limitTemperatureMaxInfo:
      '流體溫度上限（limitTemperature fvOption）。內部以克氏溫標儲存，可在單位選單切換 °C / °F。留空時會依入口溫度推導範圍，而非停用限制器。僅覆寫單側可能與推導的另一側顛倒，因此請同時設定下限與上限。',
    nonOrthCorrectorsFluid: '非正交修正（流體）',
    nonOrthCorrectorsFluidInfo:
      '流體區域每次疊代的額外壓力修正次數，用以補償歪斜網格。因流體側含邊界層，故與固體側分開設定。預設值：3。',
    nonOrthCorrectorsSolid: '非正交修正（固體）',
    nonOrthCorrectorsSolidInfo:
      '各固體區域每次疊代的額外非正交修正次數。在四面體網格上，熱傳導項本身就需要修正；若無修正，薄固體層的導熱會偏高。預設值：2。',
    laplacianLimiterSolid: '拉普拉斯限制器（固體）',
    laplacianLimiterSolidInfo:
      '固體熱傳導項保留多少非正交修正。1 為完整修正；沿用流體的 0.33 會使薄四面體層導熱偏高約 14%。預設值：1。',
    relaxHInfo:
      '控制流體能量的更新幅度。預設為 0.5。固體欄位留空時也使用此值。',
    advanced: '進階',
    relaxHSolid: '固體能量鬆弛因子',
    relaxHSolidInfo:
      '控制所有固體的能量更新幅度。留空時使用流體的值。數值越小，每次更新幅度越小。',
    validation: {
      inletVelocityRequired: '必須設定流體進口速度。',
      inletTemperatureRequired: '必須設定流體進口溫度。',
      openingNeedsInlet:
        '請指定冷卻液從哪個開口進入。這個零件有超過兩個開口，網格器只為它們編號而不猜測方向 — 若沒有任何開口標記為進口，就沒有東西在驅動流動。',
      openingNeedsOutlet:
        '請指定冷卻液從哪個開口離開。沒有出口，冷卻液無處可去，也無法完成設定。',
      openingsUnassigned_one:
        '開口 {{patches}} 未設定方向，將會被封起來。若冷卻液應該通過，請設定它。',
      openingsUnassigned_other:
        '開口 {{patches}} 未設定方向，將會被封起來。若冷卻液應該通過，請設定它們。',
      inletTemperatureImplausible:
        '進口溫度 {{kelvin}} K 不合理 — 數值為絕對克耳文溫度（室溫為 293.15 K）。您是否想輸入 °C 卻忘了換算？',
      noFluidRegion: 'CHT 恰需一個流體區域 — 目前未設定任何區域。',
      tooManyFluidRegions: 'CHT 僅允許一個流體區域；目前設定了 {{count}} 個。',
      noSolidRegion: 'CHT 至少需要一個固體區域 — 目前未設定任何區域。',
      unknownFluidMaterial:
        "區域 '{{region}}' 中的流體材料 '{{material}}' 未知。",
      fluidPropsStale:
        '流體屬性錨定於 20 °C，但進口溫度為 {{celsius}} °C — 請點按同步按鈕（↻）以在操作點重新計算密度、ν、Cp 與 k。',
      inletTempOutsideWaterRange:
        '進口溫度 {{celsius}} °C 超出已驗證的水屬性範圍（0~100 °C）；數值取端點值。',
      unknownSolidMaterial:
        "區域 '{{region}}' 中的固體材料 '{{material}}' 未知。",
      noSpecificHeat: "固體區域 '{{region}}'：材料 '{{material}}' 沒有比熱。",
      heatSourceNonPositive:
        "固體區域 '{{region}}'：熱源必須大於 0 {{unit}}（目前為 {{value}}）。若此物體不發熱，請選擇「僅熱傳導」。",
      heatSourceOutOfRange:
        "固體區域 '{{region}}'：熱源 {{value}} {{unit}} 超出典型工程範圍（{{lo}}~{{hi}} {{unit}}）— 請確認單位。",
      regionKeyMismatch:
        "區域鍵 '{{key}}' 與任何網格物體標籤都不相符 — 求解器將找不到 constant/{{key}}/polyMesh，流固耦合將為空。請重新命名區域以與網格相符。",
      noHeatSource:
        '未定義熱源 — 模擬將為等溫。請在固體區域設定熱源，或在固體面設定固定溫度 / 表面熱通量 / 對流邊界條件。',
      staleFaceBc:
        "邊界條件參考的面 '{{faceId}}' 不在所選網格中 — 求解時將無聲地變為絕熱。請移除過時的邊界條件或選擇含此面片的網格。",
    },
  },
} as const;
